import React, { ReactElement } from 'react'
import { useIntl } from 'react-intl'
import {
  IconApplication,
  IconServer
} from '@contrast-security-inc/design-system-foundations'
import { Text } from '@contrast-security-inc/design-system-typography'
import { LibraryApplication } from '../../../../../graphql/schema/types/library'
import {
  getApplicationDrilldownRoute,
  getServerDrilldownRoute
} from '../../../../../components/route'
import { LibraryServer } from '../../../helpers/ui-interfaces'
import { DrilldownLibrary } from '../../../helpers/drilldown-ui-interfaces'
import { styles } from '../drilldown-content-view/styles'

export enum SourceType {
  'Servers',
  'Applications'
}
interface Props {
  library: DrilldownLibrary
  organizationID: string
  titleKey: string
  sourceType: SourceType
}
interface SourceListItem {
  id: string
  name: string
  link: string
  icon: ReactElement
}

export const SourceList = ({
  library,
  organizationID,
  titleKey,
  sourceType
}: Props) => {
  const intl = useIntl()
  const getItemList = (): SourceListItem[] => {
    if (sourceType === SourceType.Servers && library.servers) {
      return library.servers.map((server: LibraryServer) => ({
        id: server.server_id,
        name: server.name,
        link: getServerDrilldownRoute(organizationID, server.server_id),
        icon: <IconServer size="md" color="neutral70" />
      }))
    }

    if (sourceType === SourceType.Applications && library.applications) {
      return library.applications.map((application: LibraryApplication) => ({
        id: application.id,
        name: application.name,
        link: getApplicationDrilldownRoute(organizationID, application.appId),
        icon: <IconApplication size="md" color="neutral70" />
      }))
    }

    return []
  }

  const sourceListItems = getItemList()

  return (
    <>
      {organizationID && (
        <div className={styles.SourceList}>
          <div
            data-testid={`${SourceType[sourceType]
              .toString()
              .toLowerCase()}-list`}
          >
            <h4>
              <Text color="neutral60">
                {intl.formatMessage({ id: titleKey })}
              </Text>
            </h4>
            {sourceListItems.length === 0 &&
              sourceType === SourceType.Servers && (
                <h4>
                  <Text color="neutral60">
                    {intl.formatMessage({
                      id: 'detail_libraryPanel_NoServers'
                    })}
                  </Text>
                </h4>
              )}
            {sourceListItems &&
              sourceListItems.map((sourceListItem: SourceListItem) => {
                return (
                  <div
                    className={styles.libraryOverviewRiskBodyListItem}
                    style={{ marginBottom: '5px' }}
                    key={sourceListItem.name}
                    data-testid={`${SourceType[sourceType]
                      .toString()
                      .toLowerCase()}-list-${sourceListItem.id}`}
                  >
                    {sourceListItem.icon}
                    <div
                      data-testid={`${SourceType[sourceType]
                        .toString()
                        .toLowerCase()}-${sourceListItem.id}`}
                    >
                      <a
                        role="link"
                        className={styles.libraryOverviewCVELink}
                        href={sourceListItem.link}
                        target="_blank"
                        data-e2e={`component-hyperlink-${SourceType[sourceType]
                          .toString()
                          .toLowerCase()}`}
                      >
                        {sourceListItem.name}
                      </a>
                    </div>
                  </div>
                )
              })}
          </div>
        </div>
      )}
    </>
  )
}
